import { render, staticRenderFns } from "./calendarNav.vue?vue&type=template&id=b2cc0f4e&"
import script from "./calendarNav.vue?vue&type=script&lang=js&"
export * from "./calendarNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/nav/calendarNav.vue"
export default component.exports